module.exports = __webpack_public_path__ + "img/2.3452a8d9.png";